import React, { Component } from 'react'
import classnames from "classnames";

import baseStyles from 'custom/base.styl';
import grid from './../../styles/grid.styl';

import chart from './../../img/tutorial/chart@3x.png';

class TutorialStep7 extends Component {
  render() {
    return (
      <div className={classnames(baseStyles.tutorial_content_step, baseStyles.tutorial_content_step7)}>

        <div className={classnames(grid.row, baseStyles.mb_30)}>
          <div className={classnames(grid.col_6)}>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default)}>
              <li>Times New Roman 12 pt;</li>
              <li>1-inch margins;</li>
              <li>0.5 inch indents at the beginning of each paragraph;</li>
              <li>Double-spaced page with no additional spaces between paragraphs;</li>
              <li>Hanging indent for sources;</li>
              <li>Text is aligned "flush left”;</li>
              <li>All direct quotations require page numbers (in print sources);</li>
              <li>No links on their own. Websites are properly referenced.</li>
            </ul>

            <p><b>Way too much requirements, huh? <br/> Everything’s already set in a template!</b></p>
            <a href="https://drive.google.com/file/d/1y2Jl7Cx_eNPPka6tLUyQHTvEeOIijfoQ/view?usp=sharing" target="_blank" rel="noopener noreferrer"><i className={baseStyles.download_icon} />Download template</a>
          </div>

          <div className={classnames(grid.col_6)}>
            <ul className={baseStyles.chart_list}>
              <li className={baseStyles.mla}>MLA</li>
              <li className={baseStyles.apa}>APA</li>
              <li className={baseStyles.harvard}>Harvard</li>
              <li className={baseStyles.chicago}>Chicago</li>
            </ul>

            <img src={chart} alt="chart" height="412px" />
          </div>
        </div>

      </div>
    )
  }
}

export default TutorialStep7;



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep7.js